import {useActiveOrders} from 'hooks';
import {FC, PropsWithChildren} from 'react';
import {useOrderProviderStore} from 'store/orderStore';
import {useStore} from 'store/useStore';

import {OrderContext} from './contexts/OrderContext';

// Re-export the hook for backward compatibility
export {useOrderContext} from './contexts/OrderContext';

const OrderProvider: FC<PropsWithChildren> = ({children}) => {
  const order = useStore(useOrderProviderStore, (state) => state);
  const userOrdersData = useActiveOrders();
  // because of hydration | store is not ready
  if (!order) return <>{children}</>;

  return (
    <OrderContext.Provider
      value={{
        ...order,
        ...userOrdersData,
        refetchActiveOrders: userOrdersData.refetch,
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};

export {OrderProvider};
